export const jv_banks = [
    {
        "id": "Alpha Bank",
        "key": "ALPHA",
        "name": "Alpha Bank",
        "isMain": "true",
        "code": "CRBAGRAA",
        "ibanAfmValidationWithBankKey": "ALPHA"
    },
    {
        "id": "Eurobank",
        "key": "EUROBANK",
        "name": "Eurobank",
        "isMain": "true",
        "code": "ERBKGRAA",
        "ibanAfmValidationWithBankKey": "EUROBANK"
    },
    {
        "id": "Τράπεζα Πειραιώς",
        "key": "PEIRAIOS",
        "name": "Τράπεζα Πειραιώς",
        "isMain": "true",
        "code": "PIRBGRAA",
        "ibanAfmValidationWithBankKey": "PEIRAIOS"
    },
    {
        "id": "Εθνική Τράπεζα",
        "key": "ETHNIKI",
        "name": "Εθνική Τράπεζα",
        "isMain": "true",
        "code": "ETHNGRAA",
        "ibanAfmValidationWithBankKey": "ETHNIKI"
    },
    {
        "id": "Optima bank",
        "key": "OPTIMA",
        "name": "Optima bank",
        "isMain": "true",
        "code": "IBOGGRAA",
        "ibanAfmValidationWithBankKey": "OPTIMA"
    },
    {
        "id": "Παγκρήτια Τράπεζα",
        "key": "PANCRETA",
        "name": "Παγκρήτια Τράπεζα",
        "isMain": "true",
        "code": "STPGGRAA",
        "ibanAfmValidationWithBankKey": "PANCRETA"
    },
    {
        "id": "ABBank",
        "key": "ABBANK",
        "name": "ABBank",
        "isMain": "false",
        "code": "AEBAGRAA",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "AMRO Bank",
        "key": "ABNAMRO",
        "name": "AMRO Bank",
        "isMain": "false",
        "code": "ABNANL2A",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Attica Bank",
        "key": "ATTICA",
        "name": "Attica Bank",
        "isMain": "true",
        "code": "ATTIGRAA",
        "ibanAfmValidationWithBankKey": "ATTICA"
    },
    {
        "id": "Bank of America Europe DAC",
        "key": "BOAATHENS",
        "name": "Bank of America Europe DAC",
        "isMain": "false",
        "code": "BOFAGR2X",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Bank of China (Luxembourg) S.A",
        "key": "BOCATHENS",
        "name": "Bank of China (Luxembourg) S.A",
        "isMain": "false",
        "code": "BKCHGRAA",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Bank Saderat Iran",
        "key": "SADERAT",
        "name": "Bank Saderat Iran",
        "isMain": "false",
        "code": "BSIRGRAA",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "BFF Bank S.p.A.",
        "key": "BFFGREECE",
        "name": "BFF Bank S.p.A.",
        "isMain": "false",
        "code": "BFSSITM1",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "BMW Austria Bank",
        "key": "BMWAUSTRIA",
        "name": "BMW Austria Bank",
        "isMain": "false",
        "code": "BMASGRA1",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "BNP PARIBAS",
        "key": "BNPPARIBASSS",
        "name": "BNP PARIBAS",
        "isMain": "false",
        "code": "PARBGRAX",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Citibank Europe",
        "key": "CITIBANKEUROPE",
        "name": "Citibank Europe",
        "isMain": "false",
        "code": "CITIGRAA",
        "ibanAfmValidationWithBankKey": "ALPHA"
    },
    {
        "id": "Deutsche Bank",
        "key": "DEUTSCHEBANK",
        "name": "Deutsche Bank",
        "isMain": "false",
        "code": "DEUTDESM",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "EFG Bank (Luxembourg)",
        "key": "EFGBANKLUX",
        "name": "EFG Bank (Luxembourg)",
        "isMain": "false",
        "code": "EFGBLULX",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "FCA Bank",
        "key": "FCABANK",
        "name": "FCA Bank",
        "isMain": "false",
        "code": "FCAAIT2T",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "FIMBank",
        "key": "FIMBANK",
        "name": "FIMBank",
        "isMain": "false",
        "code": "FIMBMTM3",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Hamburg Commercial Bank",
        "key": "HAMBURGCOM",
        "name": "Hamburg Commercial Bank",
        "isMain": "false",
        "code": "HSHNDEHH",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "HSBC",
        "key": "HSBCGREECE",
        "name": "HSBC",
        "isMain": "false",
        "code": "MIDLGRAA",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "J.P. Morgan AG",
        "key": "JPMORGANGREECE",
        "name": "J.P. Morgan AG",
        "isMain": "false",
        "code": "CHASDEFX",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Opel Bank SA",
        "key": "OPELBANK",
        "name": "Opel Bank SA",
        "isMain": "false",
        "code": "OPELGRA1",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "ProCredit Bank Bulgaria",
        "key": "PROCREDIT",
        "name": "ProCredit Bank Bulgaria",
        "isMain": "false",
        "code": "PRCBGRAA",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Santander Consumer Finance",
        "key": "SANTANDERCONSUMER",
        "name": "Santander Consumer Finance",
        "isMain": "false",
        "code": "SCFBESMM",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Ziraat Bankası",
        "key": "ZIRAATBANKASI",
        "name": "Ziraat Bankası",
        "isMain": "false",
        "code": "TCZBGRAT",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Unicredit Bank",
        "key": "UNICREDIT",
        "name": "Unicredit Bank",
        "isMain": "false",
        "code": "HYVEGRAA",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": "Viva Bank",
        "key": "VIVABANK",
        "name": "Viva Bank",
        "isMain": "false",
        "code": "PRXBGRAA",
        "ibanAfmValidationWithBankKey": "VIVA"
    },
    {
        "id": "VW Bank",
        "key": "VOLKSWAGENBANK",
        "name": "VW Bank",
        "isMain": "false",
        "code": "VOWADE2B",
        "ibanAfmValidationWithBankKey": ""
    },
    {
        "id": " Olympus Bank",
        "key": "SYNOLYMPOS",
        "name": " Olympus Bank",
        "isMain": "false",
        "code": "STDRGR21",
        "ibanAfmValidationWithBankKey": "OLYMPUS"
    },
    {
        "id": "Συνεταιριστική Τράπεζα Ηπείρου",
        "key": "SYNIPEIROU",
        "name": "Συνεταιριστική Τράπεζα Ηπείρου",
        "isMain": "false",
        "code": "STIOGR21",
        "ibanAfmValidationWithBankKey": "EPIRUS"
    },
    {
        "id": "Συνεταιριστική Τράπεζα Θεσσαλίας",
        "key": "SYNTHESSALY",
        "name": "Συνεταιριστική Τράπεζα Θεσσαλίας",
        "isMain": "false",
        "code": "STTKGR21",
        "ibanAfmValidationWithBankKey": "THESSALY"
    },
    {
        "id": "Συνεταιριστική Τράπεζα Καρδίτσας",
        "key": "SYNKARDITSAS",
        "name": "Συνεταιριστική Τράπεζα Καρδίτσας",
        "isMain": "false",
        "code": "STKAGRA1",
        "ibanAfmValidationWithBankKey": "KARDITSA"
    },
    {
        "id": "Συνεταιριστική Τράπεζα Κεντρικής Μακεδονίας",
        "key": "SYNCENTRALMACEDONIA",
        "name": "Συνεταιριστική Τράπεζα Κεντρικής Μακεδονίας",
        "isMain": "false",
        "code": "COESGR21",
        "ibanAfmValidationWithBankKey": "MACEDONIA"
    },
    {
        "id": "Τράπεζα Χανίων",
        "key": "SYNCHANION",
        "name": "Τράπεζα Χανίων",
        "isMain": "false",
        "code": "STXAGRA1",
        "ibanAfmValidationWithBankKey": "CHANIA"
    },
    {
        "id": "Τράπεζα Κύπρου",
        "key": "CYPRUSBANK",
        "name": "Τράπεζα Κύπρου",
        "isMain": "false",
        "code": "BCYPCY2N",
        "ibanAfmValidationWithBankKey": "PEIRAIOS"
    }
]